import React from 'react';
import TreeView from 'react-treeview';
import StakeholderParticipationLabel from './StakeholderParticipationLabel.jsx';

const StakeholdersParticipationsTree = ({
  isPreview,
  initiative,
  stakeholdersParticipations,
  activeStakeholderParticipationId,
  organization,
  status,
  slug,
}) => {
  return (
    <TreeView
      nodeLabel={
        <StakeholderParticipationLabel
          isPreview={isPreview}
          initiative={initiative}
          label={organization.name}
          slug={slug}
          isActive={activeStakeholderParticipationId === null}
        />
      }
    >
      {stakeholdersParticipations.map((stakeholder) => (
        <div className="tree-view_leaf" key={stakeholder.id}>
          <StakeholderParticipationLabel
            isPreview={isPreview}
            slug={slug}
            stakeholderParticipation={stakeholder}
            initiative={initiative}
            isActive={activeStakeholderParticipationId === stakeholder.id}
            showCompletionDot={initiative.completionTracked}
          />
        </div>
      ))}
    </TreeView>
  );
};

export default StakeholdersParticipationsTree;
